export default __webpack_public_path__ + "static/media/logoMuni.acc4b948.svg";